/**
 * PDP gallery: generic section vs per-color images (is_generic flag).
 */

export function parseIsGeneric(value) {
    return value == 1 || value === true || value === "1" ? 1 : 0;
}

/** Shown in generic gallery block (end of thumbs), not under a color. */
export function isGenericGalleryImage(element) {
    if (!element) {
        return false;
    }
    const type = (element.type || "").toLowerCase();
    if (type === "generic") {
        return true;
    }
    if (parseIsGeneric(element.is_generic)) {
        return true;
    }
    if (!element.color_id) {
        return true;
    }
    return false;
}

/** Shown only for the selected color; excludes images flagged for generic gallery. */
export function isColorGalleryImage(element, colorId) {
    if (!element || colorId == null || colorId === undefined) {
        return false;
    }
    if (String(element.color_id) !== String(colorId)) {
        return false;
    }
    if (parseIsGeneric(element.is_generic)) {
        return false;
    }
    const type = (element.type || "").toLowerCase();
    if (type === "generic") {
        return false;
    }
    return true;
}

export function appendGalleryImagePair(thumbArray, normalArray, element) {
    thumbArray.push({
        id: element.id,
        url: element.url,
        thumb_url: element.thumbnail,
        type: "image",
    });
    normalArray.push({
        id: element.id,
        url: element.url,
        type: "image",
    });
}
